import * as Yup from 'yup'

const supervisorSchema = Yup.object({
    mobile_number:Yup.string().required("INPUT.VALIDATION.MOBILENUMBER"),
    first_name:Yup.string().required('INPUT.VALIDATION.FIRSTNAME'),
    last_name:Yup.string().required('INPUT.VALIDATION.LASTNAME'),
    email:Yup.string().email().required('INPUT.VALIDATION.EMAIL')
})
export default supervisorSchema;